export default __webpack_public_path__ + "static/media/Kyle.2f8c5620.jpg";